<template>
  <v-app class="ma-0">
    <v-stepper v-model="step" vertical>
      <template v-for="i of steps">
        <v-stepper-step color="#4d62ff" :complete="step > i" :step="i">
          {{ questionBlobs[i - 1].name }}
        </v-stepper-step>
        <v-stepper-content :step="i">
          <div class="mb-12">
            <!-- start of step questions -->
            <template
              v-for="(currQuestion, Qindex) of questionBlobs[i - 1].questionSet"
            >
              <h2>{{ currQuestion.question.question }}</h2>
              <template v-if="currQuestion.question.type == 'bool'">
                <v-radio-group
                  v-model="questionBlobs[i - 1].questionSet[Qindex].Answer"
                  row
                >
                  <v-radio
                    :label="currQuestion.question.options[0]"
                    :value="currQuestion.question.options[0]"
                  ></v-radio>
                  <v-radio
                    :label="currQuestion.question.options[1]"
                    :value="currQuestion.question.options[1]"
                  ></v-radio>
                </v-radio-group>
              </template>
              <template v-if="currQuestion.question.type == 'multi'">
                <v-checkbox
                  v-for="checkValue in currQuestion.question.options"
                  v-model="questionBlobs[i - 1].questionSet[Qindex].Answer"
                  :label="checkValue"
                  :value="checkValue"
                ></v-checkbox>
              </template>
              <template v-if="currQuestion.question.type == 'number'">
                <v-row nogutters>
                  <v-col align="start" md="6" sm="12">
                    <v-text-field
                      v-model="questionBlobs[i - 1].questionSet[Qindex].Answer"
                      filled
                      single-line
                      type="number"
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
              <template v-if="currQuestion.question.type == 'text'">
                <v-row nogutters>
                  <v-col sm="12" md="6">
                    <v-text-field
                      v-model="questionBlobs[i - 1].questionSet[Qindex].Answer"
                      label="Input Value"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </template>
            </template>
            <!-- end of step questions -->
          </div>
          <template v-if="step < steps">
            <v-btn class="white--text" pr-5 color="#4d62ff" @click="step++">
              Continue
            </v-btn>
          </template>
          <template v-if="step == steps">
            <v-btn
              class="white--text"
              pr-5
              color="#4d62ff"
              @click="submitForm()"
            >
              Submit
            </v-btn>
          </template>
          <template v-if="step > 1">
            <v-btn pr-5 text @click="step--"> Back </v-btn>
          </template>
          <v-btn pr-5 text> Cancel </v-btn>
        </v-stepper-content>
      </template>
    </v-stepper>
  </v-app>
</template>

<script>
export default {
  name: "Quizz",
  components: {},
  data() {
    return {
      questionBlobs: undefined,
      step: 1,
      steps: 6,
    };
  },
  methods: {
    submitForm: function () {
      console.log(this.questionBlobs);
      this.$router.push('/SignUp')
    },
  },
  mounted() {
    this.questionBlobs = this.$store.getters.getQuestionBlobs;
    this.steps = this.questionBlobs.length;
  },
  watch: {
    // whenever questionBlobs changes, this function will run
    questionBlobs: {
      handler(newBlob) {
        console.log("updating");
        console.log(newBlob)
        this.$store.commit('setQuestionBlobs', newBlob);
      },
      deep: true
    },
  }
};
</script>